export default "__VITE_ASSET__BfgtZtb2__"